var React = require('react');

function Linaria (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M23.21,48.37H16.35a11.09,11.09,0,0,1,0-22.18,2.63,2.63,0,1,0,0-5.26,16.35,16.35,0,0,0,0,32.7h6.86A11.1,11.1,0,0,1,34.3,64.72a2.63,2.63,0,0,0,5.26,0A16.37,16.37,0,0,0,23.21,48.37Z M57.51,20.93a16.39,16.39,0,0,0-7.6,1.87A64.43,64.43,0,0,1,38,27.71a7.33,7.33,0,0,1-3.71.14A11.44,11.44,0,0,1,36.65,5.27,11.44,11.44,0,0,1,48.37,16.7a2.63,2.63,0,0,0,5.26,0A16.7,16.7,0,1,0,23.79,27a16.76,16.76,0,0,0,9.34,6,12.6,12.6,0,0,0,6.39-.22,69.61,69.61,0,0,0,12.84-5.3,11,11,0,0,1,5.15-1.26,11.09,11.09,0,1,1,0,22.18H50.65a16.35,16.35,0,0,0-8.18,2.19,2.63,2.63,0,1,0,2.63,4.56,11.08,11.08,0,0,1,5.54-1.48h6.86a16.35,16.35,0,1,0,0-32.7Z"})));
}

Linaria.defaultProps = {"viewBox":"0 0 73.86 67.35","stroke":"currentColor","fill":"currentColor","strokeWidth":"0","height":"1em","width":"1em"};

module.exports = Linaria;

Linaria.default = Linaria;
